import React from "react";
import "./ModalConfirmLogout.css";

interface IProps {
  isShowLogout: boolean;
  setIsShowLogout: () => void;
}

const ModalConfirmLogout: React.FC<IProps> = ({
  isShowLogout,
  setIsShowLogout,
}) => {
  const Cookies = require("js-cookie");

  if (!isShowLogout) return null;

  return (
    <div className="thn-logout" role="dialog" aria-modal="true" aria-labelledby="thn-logout-title">
      <button
        type="button"
        className="thn-logout__overlay"
        aria-label="Đóng"
        onClick={setIsShowLogout}
      />
      <div className="thn-logout__box">
        <button type="button" className="thn-logout__close" onClick={setIsShowLogout} aria-label="Đóng">
          ×
        </button>
        <h1 id="thn-logout-title" className="thn-logout__title">
          Đăng xuất
        </h1>
        <p className="thn-logout__text">Bạn có chắc muốn đăng xuất không?</p>
        <div className="thn-logout__actions">
          <button type="button" className="thn-logout__btn thn-logout__btn--cancel" onClick={setIsShowLogout}>
            Hủy
          </button>
          <button
            type="button"
            className="thn-logout__btn thn-logout__btn--ok"
            onClick={() => {
              Cookies.remove("access_token");
              setIsShowLogout();
              localStorage.removeItem("user_info");
              window.location.reload();
            }}
          >
            Xác nhận
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmLogout;
